// extracted by mini-css-extract-plugin
export default {"personalBox":"personal_personalBox__J27tA"};